import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import {
  Collapse, IconButton, Alert
} from '@mui/material';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { useForm } from '../../../pages/General/useForm';
import FormHelperText from '@mui/material/FormHelperText';
import Autocomplete from '@mui/material/Autocomplete';
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { fetchCountry, fetchState, fetchMultiStates } from '../../../pages/General/countryStateCitySlice';
import { fetchAddressBookDetails } from './addressbookSlice';

const RecipientAddressSelect = ({ errors, values, dispatchInputChangeCallback,dispatchCheckboxChangeCallback, addresssender, isReturnOrder, dispatchCountryCallback, newOrderFormData, setValues,choosenTrackingNumber }) => {
    const dispatch = useDispatch();
    const country_code = useSelector(state => state.countrystate.country);
    const profile = useSelector(state => state.profile);
    const state = useSelector(state => state.countrystate.state);
    const addressbooksearchvalues = useSelector((state) => state.addressbook && state.addressbook.getsearchvalues);
    const filteredCountryData = country_code.data.filter(({ code }) => code );
    const [isRecipientSearchVisible, setIsRecipientSearchVisible] = useState(false)
    const [addressSearchBy, setAddressSearchBy] = useState("name");
    const [addressSearchByValue, setAddressSearchByValue] = useState("");
    
    const handleInputChange = e => {
        const { name, value } = e.target
        dispatchInputChangeCallback(name, value)
    }
    const onSignatureChange = e => {
        const { name, value } = e.target
        dispatchCheckboxChangeCallback(name, e.target.checked)
    }
    const onChangeCountry = id => {
        dispatchCountryCallback(id)
    }

    const getSelectedCountry = (country_code) => {
        let filteredValue = { code: "", name: "" };
        filteredCountryData.map((key) => {
          if (key.code == country_code) {
            filteredValue = key;
          }
        });
         return filteredValue;
      };

      const onSelectStateChange = (currentstate) => {
        dispatchInputChangeCallback("province_code", currentstate)
      };
    
      const getSelectedState = (currentstate) => {
        let filteredStateValue = { code: "", name: "" };
        let tempState = "";
        state &&
          state.data &&
          state.data.map((key) => {
            if (key.code == currentstate && tempState == "") {
              filteredStateValue = key;
              tempState = "success";
            }
          });
        return filteredStateValue;
      };

    const recipientclick = (value) => {
        if (value == 'no') {
            setIsRecipientSearchVisible(false)
        } else {
            setIsRecipientSearchVisible(true)
        }
    }


    useEffect(() => {
        dispatch(fetchCountry());
    }, [dispatch]);


    useEffect(() => {
        if ((newOrderFormData && newOrderFormData.shipping_address && newOrderFormData.shipping_address.country_code)) {
            dispatch(fetchState(newOrderFormData && newOrderFormData.shipping_address
                && newOrderFormData.shipping_address.country_code));
        }
    }, [newOrderFormData]);

    
    useEffect(() => {
        if(isReturnOrder==undefined || isReturnOrder==false){
            dispatch(fetchAddressBookDetails(addressSearchBy, ""))
        }
    }, [addressSearchBy])

    useEffect(() => {
        if(isReturnOrder==undefined || isReturnOrder==false){
            dispatch(fetchAddressBookDetails(addressSearchBy, addressSearchByValue))
        }
    }, [addressSearchByValue])

    const [labelgetvalues, setlabelgetvalues] = useState([]);


    const onSearchLabelChange = (event, value) => {
        if (value != null && value != "") {
            setValues({
                ...values,
                name: value.name ? value.name : "",
                company: value.company ? value.company : "",
                phone: value.phone ? value.phone : "",
                email: value.email ? value.email : "",
                address: value.address ? value.address : "",
                address2: value.address2 ? value.address2 : "",
                city: value.city ? value.city : "",
                postal_code: value.postal_code ? value.postal_code : "",
                country_code: value.country_code ? value.country_code.toUpperCase() : "",
                province_code: value.province_code ? value.province_code.toUpperCase() : ""
            });
            dispatch(fetchState(value.country_code));
            
        }
    }

    useEffect(() => {
        if (addressbooksearchvalues && addressbooksearchvalues.data) {
            let searchvaluearray = []
            Object.entries(addressbooksearchvalues.data).map((entry) => {
                entry.map((item) => {
                    if (typeof item == "object") {
                        searchvaluearray.push(item)
                    }
                });
            });
            setlabelgetvalues(searchvaluearray)
        }
    }, [addressbooksearchvalues.data]);


    useEffect(() => {
        if (isReturnOrder && newOrderFormData?.shipping_address) {
            
            const originalCustomer = newOrderFormData.shipping_address || {};
            const originalWarehouse = newOrderFormData.sender_address || {};

            setValues({
                ...values,
                // --- MAP TO RECIPIENT FIELDS (Original Warehouse) ---
                name: (originalWarehouse.name || "").trim(),
                company: originalWarehouse.company || "",
                email: originalWarehouse.email || "",
                phone: originalWarehouse.phone || "",
                address: originalWarehouse.address1 || "",
                address2: originalWarehouse.address2 || "",
                city: originalWarehouse.city || "",
                postal_code: (originalWarehouse.zip || "").replace(/\s/g, ''),
                country_code: originalWarehouse.country_code || "",
                province_code: originalWarehouse.province_code || originalWarehouse.province || "",
                vat_no: originalWarehouse.vat_no || "",

                // --- MAP TO SENDER FIELDS (Original Customer) ---
                sender_name: (originalCustomer.name || "").trim(),
                sender_company: originalCustomer.company || originalCustomer.name || "",
                
                // UPDATED EMAIL LOGIC: Priority order for Return Sender email
                sender_email: profile?.profile?.default_customer_email 
                    || newOrderFormData?.customer?.email 
                    || originalCustomer?.email 
                    || profile?.profile?.email 
                    || "",

                sender_phone: originalCustomer.phone || "",
                sender_address: originalCustomer.address1 || "",
                sender_address2: originalCustomer.address2 || "",
                sender_city: originalCustomer.city || "",
                sender_postal_code: (originalCustomer.zip || "").replace(/\s/g, ''),
                sender_country_code: originalCustomer.country_code || "",
                sender_province_code: originalCustomer.province_code || originalCustomer.province || "",
                
                preferred_sender_id: "" // Reset to ensure manual address data is used
            });
        }
    }, [isReturnOrder, newOrderFormData]);
    const [isExpanded, setIsExpanded] = useState(false);
    
    const handleToggleExpand = () => {
        setIsExpanded(!isExpanded);
    };
    return (
        <>
           {/* RIGHT PART MODULE: Recipient Address Directory Configuration Surface panel */}
            <Card
                sx={{ 
                    width: '100%',
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E2E8F0',
                    borderRadius: '16px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                    overflow: 'hidden',
                    mt: '5px',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%'
                }}
                className="sc--cardhead--details"
            >
                <CardHeader 
                    title={
                        <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '15px' }}>
                            Recipient
                        </Typography>
                    } 
                    action={
                        <IconButton 
                            onClick={handleToggleExpand}
                            sx={{ color: '#64748B', '&:hover': { backgroundColor: '#F1F5F9' } }}
                        >
                            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    }
                    onClick={handleToggleExpand}
                    style={{ cursor: 'pointer' }}
                    sx={{ p: 2.5, backgroundColor: '#FFFFFF', flexShrink: 0 }}
                />
                <Divider sx={{ borderColor: '#E2E8F0' }} />
                
                <Box sx={{ flexGrow: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
                    
                    {/* Dynamic Error Banner Surface: Exposed outside of the collapse wrapper when closed */}
                    {!isExpanded && Object.values(errors).some(errorMsg => errorMsg && errorMsg !== "") && (
                        <Box sx={{ px: 2.5, pt: 2, pb: 0 }}>
                            <Alert 
                                severity="error"
                                variant="outlined"
                                sx={{ 
                                    borderRadius: '10px', 
                                    fontSize: '12.5px', 
                                    fontWeight: 600,
                                    borderColor: '#FCA5A5',
                                    backgroundColor: '#FEF2F2',
                                    color: '#991B1B',
                                    '& .MuiAlert-icon': { color: '#DC2626' }
                                }}
                            >
                                <Box sx={{ fontWeight: 700, mb: 0.5 }}>Validation errors found in Recipient Details:</Box>
                                <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                    {errors.name && <li>Name: {errors.name}</li>}
                                    {errors.email && <li>Email: {errors.email}</li>}
                                    {errors.address && <li>Address 1: {errors.address}</li>}
                                    {errors.address2 && <li>Address 2: {errors.address2}</li>}
                                    {errors.city && <li>City: {errors.city}</li>}
                                    {errors.postal_code && <li>Postal Code: {errors.postal_code}</li>}
                                    {errors.country_code && <li>Country: {errors.country_code}</li>}
                                    {errors.province_code && <li>State/Province: {errors.province_code}</li>}
                                    {errors.company && <li>Company: {errors.company}</li>}
                                </ul>
                            </Alert>
                        </Box>
                    )}

                    {/* Collapsed Dynamic Address Text Box View Panel Standard */}
                    {!isExpanded && (
                        <CardContent sx={{ p: 2.5, pt: !isReturnOrder ? 2 : 2.5, pb: 2.5 }}>
                            <Box 
                                onClick={handleToggleExpand}
                                sx={{ 
                                    p: 2, 
                                    backgroundColor: '#F8FAFC', 
                                    border: '1px solid',
                                    // Turns box border red if validation errors exist outside the expanded area
                                    borderColor: Object.values(errors).some(errorMsg => errorMsg && errorMsg !== "") ? '#FCA5A5' : '#E2E8F0', 
                                    borderRadius: '10px',
                                    cursor: 'pointer',
                                    transition: 'all 0.15s ease-in-out',
                                    '&:hover': { backgroundColor: '#F1F5F9', borderColor: '#CBD5E1' }
                                }}
                            >
                                {values.name || values.address || values.city ? (
                                    <Typography variant="body2" noWrap sx={{ color: '#334155', fontWeight: 600, width: '100%' }}>
                                        {values.name && <span>{values.name}</span>}
                                        {values.company && <span style={{ color: '#64748B', fontWeight: 500 }}>{` (${values.company})`}</span>}
                                        {(values.address || values.city) && <Box component="span" sx={{ color: '#94A3B8', mx: 1 }}>•</Box>}
                                        <Box component="span" sx={{ color: '#475569', fontWeight: 400 }}>
                                            {[values.address, values.address2, values.city, values.province_code, values.postal_code, values.country_code].filter(Boolean).join(', ')}
                                        </Box>
                                        {values.phone && (
                                            <>
                                                <Box component="span" sx={{ color: '#94A3B8', mx: 1 }}>•</Box>
                                                <span style={{ color: '#64748B', fontWeight: 400 }}>{values.phone}</span>
                                            </>
                                        )}
                                    </Typography>
                                ) : (
                                    <Typography variant="body2" sx={{ color: '#94A3B8', fontWeight: 500, fontStyle: 'italic' }}>
                                        None available. Expand to populate information.
                                    </Typography>
                                )}
                            </Box>
                        </CardContent>
                    )}

                    {/* Progressive Disclosure Collapse Wrapper Area: Encapsulates form details until explicitly toggled open */}
                    <Collapse in={isExpanded} timeout="auto" unmountOnExit sx={{ flexGrow: 1 }}>
                        <CardContent sx={{ p: 2.5, pt: 1, boxSizing: 'border-box' }}>
                            <Box
                                component="form"
                                noValidate
                                autoComplete="off"
                                sx={{ width: '100%' }}
                            >
                                <div> {/* Protective insulation block ensuring clean grid mapping overrides fallback settings safely */}
                                    <Stack spacing={2.5}>
                                         {/* 1. Recipient Address Directory Search Header Bar Section - Stays visible initially on a clean single line */}
                                        {!isReturnOrder && (
                                            <CardContent sx={{ p: 2.5, pb: isExpanded ? 1.5 : 0, flexShrink: 0 }}>
                                                <Box sx={{ p: 2, backgroundColor: '#F8FAFC', borderRadius: '12px', border: '1px solid #E2E8F0' }}>
                                                    <Grid container spacing={2} alignItems="center">
                                                        <Grid item xs={12} sm={4} style={{ minWidth: '140px' }}>
                                                            <FormControl fullWidth variant="outlined" size="small" error={!!errors.dimension_unit}>
                                                                <InputLabel id="search-by-select-outlined-label">Search by</InputLabel>
                                                                <Select
                                                                    labelId="search-by-select-outlined-label"
                                                                    id="search-by-select-outlined"
                                                                    name="search_by"
                                                                    onChange={(event) => { setAddressSearchBy(event.target.value) }}
                                                                    value={addressSearchBy}
                                                                    label="Search by"
                                                                    sx={{ 
                                                                        borderRadius: '10px',
                                                                        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E8F0' }
                                                                    }}
                                                                >
                                                                    <MenuItem value="name">Name</MenuItem>
                                                                    <MenuItem value="company">Company</MenuItem>
                                                                    <MenuItem value="address">Address</MenuItem>
                                                                    <MenuItem value="address2">Addres2</MenuItem>
                                                                    <MenuItem value="city">City</MenuItem>
                                                                    <MenuItem value="province_code">Province code</MenuItem>
                                                                    <MenuItem value="country_code">Country code</MenuItem>
                                                                    <MenuItem value="postal_code">Postal code</MenuItem>
                                                                    <MenuItem value="email">Email</MenuItem>
                                                                    <MenuItem value="phone">Phone</MenuItem>
                                                                    <MenuItem value="customer_id">Customer id</MenuItem>
                                                                    <MenuItem value="reference">Reference</MenuItem>
                                                                    <MenuItem value="reference2">Reference2</MenuItem>
                                                                    <MenuItem value="reference3">Reference3</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        
                                                        <Grid item xs={12} sm={8} sx={{ flexGrow: 1 }}>
                                                            <Autocomplete
                                                                disablePortal
                                                                size="small"
                                                                name="search_value"
                                                                id="combo-box-demo"
                                                                noOptionsText={"No matches found"}
                                                                loading={addressbooksearchvalues && addressbooksearchvalues.loading}
                                                                options={labelgetvalues || []}
                                                                filterOptions={(options) => options}
                                                                sx={{
                                                                    width: '100%',
                                                                    '& .MuiOutlinedInput-root': { 
                                                                        borderRadius: '10px',
                                                                        '& fieldset': { borderColor: '#E2E8F0' }
                                                                    }
                                                                }}
                                                                renderOption={(props, option) => (
                                                                    <MenuItem {...props} value={option._id} key={option._id} sx={{ py: 1.25, borderBottom: '1px solid #F1F5F9' }}>
                                                                        <Typography variant="body2" noWrap sx={{ color: '#1E293B', fontWeight: 500, width: '100%' }}>
                                                                            <strong>{option.name}</strong> {option.company ? `(${option.company})` : ''}
                                                                            <Box component="span" sx={{ color: '#94A3B8', mx: 1 }}>•</Box>
                                                                            <Box component="span" sx={{ color: '#64748B', fontWeight: 400 }}>
                                                                                {option.address}, {option.city}, {option.province_code}, {option.country_code} - {option.postal_code}
                                                                            </Box>
                                                                        </Typography>
                                                                    </MenuItem>
                                                                )}
                                                                onInputChange={(event, value, reason) => {
                                                                        if ( ! value.includes(",") && reason != "reset") {
                                                                            setAddressSearchByValue(value)
                                                                        }
                                                                    }
                                                                }
                                                                onChange={(event, value) => onSearchLabelChange(event, value)}
                                                                getOptionLabel={(option) => ( ""+option.name+" ("+option.company+")"+", "+ option.address ) }
                                                                renderInput={(params) => (
                                                                    <TextField 
                                                                        {...params} 
                                                                        label="Search Recipient Directory..." 
                                                                        variant="outlined"
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </CardContent>
                                        )}
                                        {/* 2. Core Identification Profile Row Module Field Group */}
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    label="Name*"
                                                    name="name"
                                                    value={values.name}
                                                    multiline
                                                    onChange={handleInputChange}
                                                    error={!!errors.name}
                                                    helperText={errors.name}
                                                    sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <TextField id="standard-basic"
                                                    label="Company"
                                                    variant="outlined"
                                                    size="small"
                                                    name="company"
                                                    value={values.company}
                                                    onChange={handleInputChange}
                                                    error={!!errors.company}
                                                    helperText={errors.company}
                                                    sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <TextField id="standard-basic"
                                                    label="Phone Number"
                                                    name="phone"
                                                    size="small"
                                                    value={values.phone}
                                                    variant="outlined"
                                                    onChange={handleInputChange}
                                                    sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }}
                                                />
                                            </Grid>
                                        </Grid>

                                        {/* 3. Electronic Mail & Geographic Location Descriptors Module Field Group */}
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={4}>
                                                <TextField id="standard-basic"
                                                    label="Email"
                                                    variant="outlined"
                                                    size="small"
                                                    name="email"
                                                    value={values.email}
                                                    onChange={handleInputChange}
                                                    error={!!errors.email}
                                                    helperText={errors.email}
                                                    sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <TextField id="standard-basic"
                                                    label="Address1*"
                                                    variant="outlined"
                                                    size="small"
                                                    name="address"
                                                    value={values.address}
                                                    inputProps={{ maxLength: 35 }}
                                                    onChange={handleInputChange}
                                                    error={!!errors.address}
                                                    helperText={errors.address}
                                                    sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <TextField id="standard-basic"
                                                    label="Address2"
                                                    variant="outlined"
                                                    size="small"
                                                    name="address2"
                                                    value={values.address2}
                                                    inputProps={{ maxLength: 35 }}
                                                    onChange={handleInputChange}
                                                    error={!!errors.address2}
                                                    helperText={errors.address2}
                                                    sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }}
                                                />
                                            </Grid>
                                        </Grid>

                                        {/* 4. Municipal Logistics Regional Demographics Localization Module Field Group */}
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={4}>
                                                <TextField id="standard-basic"
                                                    label="City*"
                                                    variant="outlined"
                                                    size="small"
                                                    name="city"
                                                    value={values.city}
                                                    onChange={handleInputChange}
                                                    error={!!errors.city}
                                                    helperText={errors.city}
                                                    sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <TextField id="standard-basic"
                                                    label="Postal Code*"
                                                    variant="outlined"
                                                    size="small"
                                                    name="postal_code"
                                                    inputProps={{ maxLength: 10 }}
                                                    value={values.postal_code.toUpperCase()}
                                                    onChange={handleInputChange}
                                                    error={!!errors.postal_code}
                                                    helperText={errors.postal_code}
                                                    sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    className="help-text-error"
                                                    disablePortal
                                                    size="small"
                                                    name="country_code"
                                                    id="country-select-demo"
                                                    options={filteredCountryData || []}
                                                    autoHighlight
                                                    loading={country_code && country_code.loading}
                                                    getOptionLabel={(option) => option.name || ""}
                                                    value={getSelectedCountry(values && values.country_code)}
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiOutlinedInput-root': { 
                                                            borderRadius: '10px',
                                                            '& fieldset': { borderColor: '#E2E8F0' }
                                                        }
                                                    }}
                                                    renderOption={(props, option) => (
                                                    <MenuItem {...props} value={option.code} key={option.code} sx={{ fontSize: '13px' }}>
                                                        {option.icon} {option.name}
                                                    </MenuItem>
                                                    )}
                                                    onChange={(event, value) => {
                                                    if (value !== null) {
                                                        onChangeCountry(value.code);
                                                    } else {
                                                        onChangeCountry("");
                                                    }
                                                    }}
                                                    renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="country*"
                                                        variant="outlined"
                                                        helperText={errors.country_code}
                                                        error={!!errors.country_code}
                                                    />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>

                                        {/* 5. Secondary Regional Territorial Jurisdictions Autocomplete & Border Crossings Customs Module Field Group */}
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={6}>
                                                <Autocomplete
                                                    className="help-text-error"
                                                    disablePortal
                                                    size="small"
                                                    name="province_code"
                                                    id="state-select-demo"
                                                    options={state && state.data || []}
                                                    autoHighlight
                                                    loading={(state && state.loading) || (country_code && country_code.loading)}
                                                    getOptionLabel={(option) => option.name || ""}
                                                    value={getSelectedState(values && values.province_code)}
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiOutlinedInput-root': { 
                                                            borderRadius: '10px',
                                                            '& fieldset': { borderColor: '#E2E8F0' }
                                                        }
                                                    }}
                                                    renderOption={(props, option) => (
                                                    <MenuItem {...props} value={option.code} key={option.code} sx={{ fontSize: '13px' }}>
                                                        {option.name}
                                                    </MenuItem>
                                                    )}
                                                    onChange={(event, value) => {
                                                        if (value !== null) {
                                                        onSelectStateChange(value.code);
                                                        } else {
                                                        onSelectStateChange("");
                                                        }
                                                    }}
                                                    renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="state*"
                                                        variant="outlined"
                                                        helperText={errors.province_code}
                                                        error={!!errors.province_code}
                                                    />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField id="standard-basic"
                                                    label="VAT/EORI"
                                                    variant="outlined"
                                                    size="small"
                                                    name="vat_no"
                                                    value={values.vat_no}
                                                    inputProps={{ maxLength: 35 }}
                                                    onChange={handleInputChange}
                                                    sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Stack>
                                </div>
                            </Box>
                        </CardContent>
                    </Collapse>
                </Box>
            </Card>
        </>
    )
};

export default RecipientAddressSelect;